<template>
  <div class="map-heatmaps">
    <heatmap2d
      :id="id"
      :layer-style="layerStyle"
      :layer-controller="layerController"
      :heatmap-controller="heatmapController"
    />
    <heatmap3d
      :id="id"
      :layer-style="layerStyle"
      :layer-controller="layerController"
      :heatmap-controller="heatmapController"
    />
  </div>
</template>

<script>
import Heatmap2d from "./heatmap-2d";
import Heatmap3d from "./heatmap-3d";

export default {
  props: ["id", "layer-style", "layer-controller", "heatmap-controller"],
  components: {
    Heatmap2d,
    Heatmap3d
  }
};
</script>

<style lang="scss">
.map-heatmaps {
  &__loader {
    padding-left: 15px;

    .el-icon-loading {
      font-size: 16px;
      margin-right: 5px;
      vertical-align: middle;
    }

    span {
      vertical-align: middle;
    }
  }

  &__slider {
    &:not(:first-child) {
      margin-top: 8px;
    }
  }

  &__color {
    margin-top: 8px;
  }

  .el-select-dropdown__item {
    height: 36px !important;
    line-height: 36px !important;
  }
}
</style>
